import { oBase, Ilk, oBool, oColor, oCsv, oDaton, oDatim, oDouble, oFloat, oHomin, oInt16, oInt32, oInt64, oMay, oMemo, oText, oWkd } from "../util/ovars";
import { jsDebug } from "../util/classes";
import { UTL } from "../util/classes";
import { TRANS } from "../util/classes";
import { TABLE, TableObject, TBLSCROLLER, TABLE_Location } from "../util/classes";
import { Elcon } from "../util/classes";
import { DLG } from "../util/classes";
import { GSP } from "../util/classes";
import { Whisper } from "../util/classes";
import { VECTOR, VECTOR_Task, VECTOR_Capsule, VECTOR_Info } from "../util/classes";
import { CdFnCntPayload } from "../util/classes";
import { COMM_LOGIC_TYPE } from "../util/classes";
import { DIALOG500 } from "../util/dialog500";
import { cmux_refresh_site } from "../apps/cmux_general";
import { FacadePlus } from "../util/popupPlus_Facade";
import { NotifyPlus } from "../util/popupPlus_Notify";




export async function execute_sys_api_reload(): Promise<void> {
    // location.reload() :של פונקציה זו אשר מבצעת גם ext להזכירך: יש גם גרסה
    // location.reload() :של פונקציה זו אשר מבצעת גם ext להזכירך: יש גם גרסה
    // location.reload() :של פונקציה זו אשר מבצעת גם ext להזכירך: יש גם גרסה
    // location.reload() :של פונקציה זו אשר מבצעת גם ext להזכירך: יש גם גרסה
    FacadePlus.Append_wait("reload");
    if (jsDebug.long_sleep_when_check_if_reload_needed == true) {
        await UTL.sleep_async(2000); // relaxer בגלל שהפעולה הזאת מהירה ואנחנו רוצים לראות את ה
    }
    const token: string = UTL.ASP_GetAntiForgeryToken();
    const url: string = `/sys/sys_api_perform_reload/`;
    const fetch_options = {} as RequestInit; // remember that RequestInit is an interface for  fetch options
    fetch_options.method = "POST";
    fetch_options.headers = { 'Content-Type': 'application/json', 'RequestVerificationToken': token };
    fetch_options.cache = "no-store";
    fetch_options.body = JSON.stringify({}); // send an empty JSON object
    await fetch(url, fetch_options);
    NotifyPlus.Close();
}




export async function execute_sys_api_reload_ext(): Promise<void> {
    // ext means: add: "location.reload();"
    // ext means: add: "location.reload();"
    // ext means: add: "location.reload();"
    await execute_sys_api_reload();
    location.reload();
}




export async function execute_sys_api_publish(): Promise<void> {
    // location.reload() :של פונקציה זו אשר מבצעת גם ext להזכירך: יש גם גרסה
    // location.reload() :של פונקציה זו אשר מבצעת גם ext להזכירך: יש גם גרסה
    // location.reload() :של פונקציה זו אשר מבצעת גם ext להזכירך: יש גם גרסה
    // location.reload() :של פונקציה זו אשר מבצעת גם ext להזכירך: יש גם גרסה
    FacadePlus.Append_wait("fouce reload");
    await UTL.sleep_async(200); // relaxer בגלל שהפעולה הזאת מהירה ואנחנו רוצים לראות את ה
    const url: string = `/sys/sys_api_publish/`;
    const token: string = UTL.ASP_GetAntiForgeryToken();
    const fetch_options = {} as RequestInit; // remember that RequestInit is an interface for  fetch options
    fetch_options.method = "POST";
    fetch_options.headers = { 'Content-Type': 'application/json', 'RequestVerificationToken': token };
    fetch_options.cache = "no-store";
    fetch_options.body = JSON.stringify({}); // send an empty JSON object
    await fetch(url, fetch_options);
    NotifyPlus.Close();
}



export async function execute_sys_api_publish_ext(): Promise<void> {
    // ext means: add: "location.reload();"
    // ext means: add: "location.reload();"
    // ext means: add: "location.reload();"
    await execute_sys_api_publish();
    location.reload();
}



export interface execute_sys_api_check_if_reload_needed_REC_interface {
    // wrapper ולכן לא ניתן להחניס אותו ל interface שים לב שזהו
    // wrapper ולכן לא ניתן להחניס אותו ל interface שים לב שזהו


    // server אשר ב C# כדי לדעת האם הם נכונים יש לגשת בקוד ב server השדות האלה נלקחים ממה שמחזיר ה
    // server אשר ב C# כדי לדעת האם הם נכונים יש לגשת בקוד ב server השדות האלה נלקחים ממה שמחזיר ה
    // server אשר ב C# כדי לדעת האם הם נכונים יש לגשת בקוד ב server השדות האלה נלקחים ממה שמחזיר ה
    load_time: string;
    publish_time: string;
    reload_needed: boolean;
}

export async function execute_sys_api_check_if_reload_needed(): Promise<execute_sys_api_check_if_reload_needed_REC_interface> {
    // כיוון שפונקציה זו אינה משפיעה על הנתונים היא רק מחזירה אינפורמציה reload_page_flag פונקציה זו אינה מקבלת פרמטר
    // כיוון שפונקציה זו אינה משפיעה על הנתונים היא רק מחזירה אינפורמציה reload_page_flag פונקציה זו אינה מקבלת פרמטר
    // כיוון שפונקציה זו אינה משפיעה על הנתונים היא רק מחזירה אינפורמציה reload_page_flag פונקציה זו אינה מקבלת פרמטר
    const token: string = UTL.ASP_GetAntiForgeryToken();
    const fetch_options = {} as RequestInit; // remember that RequestInit is an interface for  fetch options
    fetch_options.method = "GET";
    fetch_options.headers = { 'Content-Type': 'application/json', 'RequestVerificationToken': token };
    const url_str: string = `/sys/sys_api_check_if_reload_needed`;
    await FacadePlus.Append_wait("בודק אם צריך לטעון נתונים");



    if (jsDebug.long_sleep_when_check_if_reload_needed == false) {
        await UTL.sleep_async(100);
    }
    if (jsDebug.long_sleep_when_check_if_reload_needed == true) {
        await UTL.sleep_async(500); // relaxer בגלל שהפעולה הזאת מהירה ואנחנו רוצים לראות את ה
    }
    let response = await fetch(url_str, fetch_options);
    const REC: execute_sys_api_check_if_reload_needed_REC_interface = await response.json();
    NotifyPlus.Close();
    return REC;
}



export async function execute_sys_api_make_site_locked_for_changes(): Promise<void> {
    alert("not implemented")
}

export async function execute_sys_api_is_site_locked_for_changes(): Promise<void> {
    alert("not implemented")
}

export async function execute_sys_api_toggle_windshild_length(): Promise<void> {
    alert("not implemented")
}




export async function HTMD101_respond_ok_button(): Promise<void> {
    //alert("HTMD101_respond_ok_button")
    const overlay_element: HTMLElement = document.getElementById("HTMD101-overlay");
    const popup_element: HTMLElement = document.getElementById("HTMD101-popup");
    const caption_element: HTMLElement = document.getElementById("HTMD101-caption");
    const panel_element: HTMLElement = document.getElementById("HTMD101-panel");
    const message_element: HTMLElement = document.getElementById("HTMD101-message");
    const ok_button: HTMLElement = document.getElementById("HTMD101-ok-button");
    const close_button: HTMLElement = document.getElementById("HTMD101-close-button");
    caption_element.style.display = "none";
    panel_element.style.display = "none";
    message_element.innerHTML = `<p>מתבצעת טעינה. יש להמתין</p>`;
    message_element.style.marginTop = "0";
    if (false) {
        overlay_element.style.display = "none"; // hides everything inside
        //await UTL.sleep_async(0);
        //לפני הפקודה שממשיכה refresh חשוב מאד!!: התפקיד של השורה הבאה הוא לבצע
        //לפני הפקודה שממשיכה refresh חשוב מאד!!: התפקיד של השורה הבאה הוא לבצע
        //לפני הפקודה שממשיכה refresh חשוב מאד!!: התפקיד של השורה הבאה הוא לבצע 
        if (false) {
            requestAnimationFrame(() => {
                execute_sys_api_reload(); // runs after the overlay is visually hidden
            });
        }
        await execute_sys_api_reload();
    }
    if (false) {
        await UTL.sleep_async(1500);
    }
    if (true) {
        overlay_element.style.display = "none"; // hides everything inside
        await execute_sys_api_reload();
        location.reload();
    }
}



export async function HTMD101_respond_close_button(): Promise<void> {
    //alert("HTMD101_respond_close_button")
    const overlay: HTMLElement = document.getElementById("HTMD101-overlay");
    overlay.style.display = "none"; // hides everything inside
}


export async function HTMD102_respond_ok_button(): Promise<void> {
    const overlay: HTMLElement = document.getElementById("HTMD102-overlay");
    overlay.style.display = "none"; // hides everything inside
}

export async function HTMD102_respond_close_button(): Promise<void> {
    const overlay: HTMLElement = document.getElementById("HTMD102-overlay");
    overlay.style.display = "none"; // hides everything inside
}




export async function submit_form_to_tblsystem(): Promise<void> {
    alert("Stripe clicked2");
    debugger;
    const form: HTMLFormElement = document.createElement('form');
    form.action = "/sys/sys_tbl_system/";
    form.method = "GET"; // i.e. "GET" or "POST"
    //UTL.add_hidden_input_to_form(form, "csrfmiddlewaretoken", UTL.GetCookie('csrftoken'));
    const pde: HTMLElement = document.getElementById("id-page-data"); // pde = Page Data Element
    const token: string = UTL.ASP_GetAntiForgeryToken();
    //UTL.add_hidden_input_to_form(form, "__RequestVerificationToken", token);

    UTL.add_hidden_input_to_form(form, "viewport", `${window.innerWidth}x${window.innerHeight}`)
    UTL.add_hidden_input_to_form(form, "FORM-ID", "ID_SUBMITTER_FORM")
    //UTL.add_hidden_input_to_form(form, "BUTTON-ID", p_button_name)

    //UTL.add_hidden_input_to_form(form, "lang", pde.dataset.lang);
    //UTL.add_hidden_input_to_form(form, "org_code", pde.dataset.org_code);

    // Add the form to the document and submit it
    document.body.appendChild(form);
    form.submit();
}

export const sys_general_wrapper = {
    // export הוא להוות אובייקט למטרת wrapper המטרה של ה
    // export הוא להוות אובייקט למטרת wrapper המטרה של ה
    // export הוא להוות אובייקט למטרת wrapper המטרה של ה
    execute_sys_api_reload,
    execute_sys_api_reload_ext,
    execute_sys_api_publish,
    execute_sys_api_publish_ext,
    execute_sys_api_check_if_reload_needed,
    execute_sys_api_make_site_locked_for_changes,
    execute_sys_api_is_site_locked_for_changes,
    execute_sys_api_toggle_windshild_length,
    HTMD101_respond_ok_button,
    HTMD101_respond_close_button,
    HTMD102_respond_ok_button,
    HTMD102_respond_close_button,
    submit_form_to_tblsystem
};

